import { submitIntakeFormCustomerThunk } from 'actions/intakeForm/IntakeFormActions';
import { CustomerForm } from 'components/Customer/Form/CustomerForm';
import ErrorList from 'components/Form/ErrorList/ErrorList';
import { LeftColumn } from 'components/Layout/TwoColumns/LeftColumn/LeftColumn';
import { MarketplaceInfo } from 'components/Marketplace/Info/MarketplaceInfo';
import { Button } from 'components/UI/Button/Button';
import { Spinner } from 'components/UI/Spinner/Spinner';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    getIntakeFormCustomer,
    getIntakeFormLoading
} from 'reducers/intakeForm/IntakeFormSelectors';
import { getIntakeFormQuestions, getMarketplace } from 'reducers/marketplace/MarketplaceSelectors';
import { AlertScreen } from 'types/Alert';
import { Customer } from 'types/Customer';
import { IntakeFormCustomQuestionCategory } from 'types/IntakeForm';

export const IntakeFormCustomer: React.FC = () => {
    const dispatch = useDispatch();
    const marketplace = useSelector(getMarketplace);
    const customer = useSelector(getIntakeFormCustomer);
    const isLoading = useSelector(getIntakeFormLoading);
    const intakeFormQuestions = useSelector(getIntakeFormQuestions);

    const formRef = React.useRef<HTMLFormElement>(null);

    const customerQuestions = React.useMemo(() => {
        return intakeFormQuestions?.filter(
            question => question.category === IntakeFormCustomQuestionCategory.FOR_CUSTOMER
        );
    }, [intakeFormQuestions]);

    const [isValid, setIsValid] = React.useState(false);

    const tiggerSubmitHandler = () => {
        formRef.current?.submit();
    };

    const submitHandler = (customer: Customer) => {
        dispatch(submitIntakeFormCustomerThunk(customer));
    };

    return (
        <LeftColumn
            footer={
                <Button fullWidth disabled={!isValid || isLoading} onClick={tiggerSubmitHandler}>
                    Continue
                </Button>
            }
        >
            <MarketplaceInfo hideLogo marketplace={marketplace} className="mb-6 pb-2" />

            <h1 className="h1 underlined">Intake form</h1>

            {isLoading && (
                <div className="w-full text-center mt-6">
                    <Spinner size={50} />
                </div>
            )}

            <ErrorList screen={AlertScreen.IntakeFormCustomer} className="mt-6" />

            {!isLoading && (
                <CustomerForm
                    ref={formRef}
                    defaultValues={customer}
                    questions={customerQuestions}
                    onChange={setIsValid}
                    onSubmit={submitHandler}
                />
            )}
        </LeftColumn>
    );
};
